import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

/**
 * Body for unmatched routes.
 *
 * The HTTP 404 status itself comes from functions/_middleware.js — React only
 * supplies the body. Both halves are required: without the middleware the page
 * is a soft 404 (HTTP 200), and without this component the middleware's 404 is
 * a blank <main>.
 *
 * Reuses existing welcome-section / draw-card-btn classes so it needs no new CSS.
 */
const NotFound = () => {
  const { t, currentLanguage } = useLanguage();
  const langSuffix = currentLanguage === 'en' ? '' : `?lang=${currentLanguage}`;

  return (
    <div className="not-found-page">
      <section className="welcome-section">
        <div className="welcome-content">
          <div className="welcome-text">
            <h1 className="welcome-subtitle">{t('notFound.title')}</h1>
            <p>{t('notFound.body')}</p>
            <Link to={`/${langSuffix}`} className="draw-card-btn">
              {t('notFound.cta')}
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default NotFound;
